import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {FrameAccurateComponent} from './frame-accurate.component';

@NgModule({
    declarations: [
        FrameAccurateComponent
    ],
    exports: [
        FrameAccurateComponent
    ],
    imports: [
        CommonModule,
        SharedModule
    ]
})
export class FrameAccurateModule { }
